import React from 'react';
import { type AggregatedMetrics } from '@prerender/prerender-shared/FE';
import { Bar } from 'react-chartjs-2';

import { numberFormatter } from '~library/numbers';
import { ColorsList, getXAxisConfig } from '../Chart';
import { crawlerTypeLabel } from '~features/crawler-filter';
import { useIsPrinting } from '~library/print';

export const MAIN_CHART_ID = 'crawler-type-main-chart';

type CrawlerTypeMainChartProps = {
  intervals: string[];
  crawlerTypesData: [string, number[]][];
  granularity: AggregatedMetrics.IntervalGranularity;
};

function CrawlerTypeMainChart({ intervals, crawlerTypesData, granularity }: CrawlerTypeMainChartProps) {
  const { isPrinting } = useIsPrinting();
  const crawlerTypeDatasets = React.useMemo(
    () =>
      crawlerTypesData.map(([category, data], i) => ({
        type: 'bar' as const,
        label: crawlerTypeLabel(category),
        data,
        backgroundColor: ColorsList[i],
        borderColor: ColorsList[i],
      })),
    [crawlerTypesData]
  );

  return (
    <Bar
      id={MAIN_CHART_ID}
      data={{
        labels: intervals,
        datasets: crawlerTypeDatasets,
      }}
      options={{
        animation: isPrinting ? false : undefined,
        scales: {
          x: getXAxisConfig(granularity),
          y: {
            ticks: {
              count: 5,
              callback: (value) => numberFormatter.format(Number(value)),
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (context) => `${context.dataset.label}: ${context.formattedValue}`,
            },
          },
        },
      }}
    />
  );
}

export default CrawlerTypeMainChart;
